import { LDClient } from 'launchdarkly-js-client-sdk';

let sharedLDClient: LDClient | null = null;

export const setLaunchDarklyClient = (client: LDClient): void => {
  if (!sharedLDClient) {
    sharedLDClient = client;
  }
};

export const getLaunchDarklyClient = (): LDClient => {
  if (!sharedLDClient) {
    throw new Error(
      'LaunchDarkly client not initialized. Ensure LDProvider is used in React and middleware is set.',
    );
  }
  return sharedLDClient as LDClient;
};

export const getFlag = async ({
  flagKey,
  defaultValue = false,
  context,
}: {
  flagKey: string;
  defaultValue: boolean;
  context?: Record<string, string> | null;
}): Promise<boolean> => {
  const client = getLaunchDarklyClient();
  if (context) {
    await client.identify(context);
  }
  return client.variation(flagKey, defaultValue);
};
